<template>
  <ul class="over-view">
    <x-angleIcon></x-angleIcon>
    <li v-for="(item, index) of overViewList" :key="index">
      <p>
        {{item.title}}
        <a-tooltip overlayClassName="over-view-tip" v-if="item.title === '认证总数'">
          <template slot="title">通过小区认证的用户总数，有多套房、多个身份的用户只统计一次</template>
          <a-icon type="info-circle" />
        </a-tooltip>
      </p>
      <p><span>{{item.value}}</span> {{item.unit}}</p>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'baseData',
  data () {
    return {
      cId: '',
      overViewList: [],
      baseDataKey: {
        users: {title: '认证总数', unit: '人'},
        owners: {title: '业主', unit: '人'},
        families: {title: '家属', unit: '人'},
        tenants: {title: '租户', unit: '人'},
        properties: {title: '物业公司', unit: '家'},
        communities: {title: '小区', unit: '个'},
        buildings: {title: '楼栋数', unit: '栋'},
        units: {title: '单元数', unit: '个'},
        positions: {title: '位置数', unit: '个'},
        rooms: {title: '房间数', unit: '间'},
        devices: {title: '设备数', unit: '台'}
      }
    };
  },
  created () {
    this.getDataViewQuery(this);
  },
  mounted () {
    this.getBaseData();
  },
  methods: {
    /* 获取基础数据 */
    getBaseData () {
      this.$get({
        url: '/zw_statistics/base_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        if (data && Object.keys(data).length) {
          let arr = [];
          if (this.cId) {
            for (let item in this.baseDataKey) { // 如果选择了小区，去除物业公司和小区统计
              if (item === 'properties' || item === 'communities') {
                delete this.baseDataKey[item];
              }
            }
          }
          for (let item in this.baseDataKey) {
            if (data.hasOwnProperty(item)) {
              arr.push({
                title: this.baseDataKey[item].title,
                value: data[item],
                unit: this.baseDataKey[item].unit
              });
            }
          }
          this.overViewList = arr;
        }
      });
    }
  }
};

</script>

<style scoped>
</style>
